export const localStore = {
  /**
   * Local Storage set with time to live
   *
   * @example expireMs
   * for a week
   *
   * setStorage('emoji', {emoji:[]}, 60 * 60 * 24 * 7)
   *
   * @param {object} params
   * @param {string} params.key key
   * @param {string} params.data data
   * @param {string} params.expireMs ms default 30 days
   * @param {string} version optional
   *
   */
  setItem(key, data, { expireMs = 60 * 60 * 24 * 30, version = 'v0' } = {}) {
    const now = new Date();

    const item = {
      version,
      data,
      expiry: now.getTime() + 1000 * expireMs,
    };

    localStorage.setItem(key, JSON.stringify(item));
  },

  /**
   * Get item from Local Storage
   *
   * @param {string} key
   * @param {string} version optional
   */
  getItem(key, version = 'v0') {
    const itemStr = localStorage.getItem(key);

    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry || !item.hasOwnProperty('version') || (item.hasOwnProperty('version') && item.version !== version)) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.data;
  },

  /**
   * Remove data from Local Storage
   *
   * @param {string} key
   */
  removeItem(key) {
    const itemStr = localStorage.getItem(key);

    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }

    // and return null
    localStorage.removeItem(key);
  },
};
